// ============================================================
//  ADMIN-DASHBOARD — Startpunkt der Redaktion, verlinkt in die
//  einzelnen Verwaltungsbereiche (folgen in Runde 2 der CMS-UI).
// ============================================================
import { Link } from "react-router-dom";
import { useAuth } from "../../cms/AuthContext";

export default function Dashboard() {
  const { user, role } = useAuth();

  const bereiche = [
    { label: "News", to: "/admin/news" },
    { label: "Teams", to: "/admin/teams" },
    { label: "Sponsoren & Trägervereine", to: "/admin/sponsoren" },
    { label: "Site-Settings", to: "/admin/einstellungen" },
  ];

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <div className="mb-10">
        <h1 className="text-2xl font-extrabold uppercase text-primary">Willkommen, {user.email}</h1>
        <p className="text-sm text-dark/60">Rolle: {role}</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        {bereiche.map((b) => (
          <Link
            key={b.to}
            to={b.to}
            className="block border border-dark/10 px-5 py-4 font-semibold hover:border-primary hover:text-primary transition-colors"
          >
            {b.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
